import { IUnit } from 'app/api/unit/model/unit-management'
import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseDatePicker } from 'app/components/common/pickers/BaseDatePicker'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import { usePagination } from 'app/hook'
import { useGetAreaList } from 'app/react-query/hook/location'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { t } from 'i18next'
import {
  Dates,
  FONT_SIZE,
  FONT_WEIGHT,
  FORMAT_ONLY_MONTH
} from 'parkway-web-common'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import { IFilterStrategicDoctorReport } from '../../type'

interface IProps {
  onChange?: (value: IFilterStrategicDoctorReport) => void
  formData?: IFilterStrategicDoctorReport
}

export const FilterLayout: React.FC<IProps> = ({ formData, onChange }) => {
  const { data: dataArea, isLoading: isLoadingJobTitle } =
    useGetAreaList({
      typeid: "area",
      pageSize: 10,
      pagesize: 10,
      status: 1,
    })
  const { flattenDataList } = usePagination()

  const jobTitleList: IUnit[] = useMemo(() => {
    const res: IUnit[] =
      flattenDataList(dataArea)
    return res
  }, [dataArea])

  const onChangeYear = (value: string) => {
    onChange && onChange({ ...formData, year: value })
  }

  const onChangeMonth = (_, value: string) => {
    onChange && onChange({ ...formData, month: value })
  }

  const onChangeArea = (value: string) => {
    onChange && onChange({ ...formData, area: value })
  }

  return (
    <BaseForm>
      <RootWrapper gutter={[16, 8]} align={'middle'}>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <Picker
              $prefix={t(R.strings.year)}
              picker="year"
              value={
                formData?.year ? Dates.getDate(`${formData?.year}-01-01`) : null
              }
              onChange={(_, value) => onChangeYear(value)}
              allowClear={false}
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <Picker
              $prefix={t(R.strings.month)}
              picker="month"
              value={
                formData?.year && formData?.month
                  ? Dates.getDate(`${formData?.year}-${formData?.month}-01`)
                  : null
              }
              onChange={onChangeMonth}
              allowClear={true}
              $prefixWidth={70}
              placeholder={t(R.strings.all_month)}
              format={FORMAT_ONLY_MONTH}
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={6}>
          <BaseFormItem hiddenLabel>
            <BaseSelectWrapper
              showSearch
              placeholder={t(R.strings.all_area)}
              allowClear
              onChange={value => onChangeArea(value as string)}
              options={jobTitleList?.map(item => ({
                value: item._id,
                label: item.name,
              }))}
              loading={isLoadingJobTitle}
              $prefix={t(R.strings.area)}
            />
          </BaseFormItem>
        </BaseCol>
      </RootWrapper>
    </BaseForm>
  )
}

const RootWrapper = styled(BaseRow)`
  padding: 8px;
  padding-bottom: 0px;
`
const Picker = styled(BaseDatePicker)<{
  $prefix: string
  $prefixWidth?: number
}>`
  width: 100%;
  border: 1px solid ${convertedVariables.neutralBlack9Color};
  &:hover {
    border: 1px solid ${convertedVariables.neutralBlack9Color};
  }
  .ant-picker-input::before {
    content: '${props => props?.$prefix ?? '-'}:';
    font-size: ${FONT_SIZE.xs};
    font-weight: ${FONT_WEIGHT.medium};
    color: ${convertedVariables.primaryColor};
    opacity: 0.4;
    width: ${props => props?.$prefixWidth ?? 50}px;
  }
`

const BaseSelectWrapper = styled(BaseSelect)<{
  $prefix: string
  $prefixWidth?: number
}>`
  width: 100%;
  .ant-select-selector::before {
    content: '${props => props?.$prefix ?? '-'}:';
    font-size: ${FONT_SIZE.xs};
    font-weight: ${FONT_WEIGHT.medium};
    color: ${convertedVariables.primaryColor};
    opacity: 0.4;
    width: ${props => props?.$prefixWidth ?? 65}px;
    align-items: center;
    display: flex;
  }
`

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px !important;
`
